import { useApiQuery } from '@/api/hooks/useQuery';
import { campaignKeys } from '@/api/queryKeys';

/**
 * Hook to fetch a single campaign using Member Gateway SDK
 * Returns CampaignServiceCampaignDetail
 */
export function useCampaign(id: number) {
  return useApiQuery({
    queryKey: campaignKeys.detail(id),
    queryFn: (api) => async () => {
      const response = await api.campaigns.campaignsControllerGetCampaignDetails(id);
      return response.data;
    },
    enabled: !!id && id > 0,
  });
}
